// El piso de plan de un modo con RUTA PROPIA, vuelto a mirar en la pantalla porque la URL se puede escribir a mano: las
// listas ya le ponen candado con `getModePlanLock`, esto es para quien entra directo. Salió de
// `DisenoIndumentariaMode` (ADR-2026-09-18-el-modo-diseno-se-abre-a-moda-desde-pro) cuando Videos cortos pasó a Pro
// (ADR-2026-10-31-videos-cortos-es-de-pro-y-ultra). Los dev testers pasan, como en todos los candados; mientras no se
// sabe el plan no se bloquea (el mismo criterio que `getModePlanLock` con plan desconocido).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { useUserGroup } from '../hooks/useUserGroup';
import { getModePlanLock, type ModePlanLock } from '../lib/planCapabilities';
import { getUserPlan } from '../lib/planUtils';

/** El candado de ese modo para la empresa (con el plan real de `company_profiles`), o null. */
export function usePisoDePlan(kind: string): ModePlanLock | null {
  const { isDevTester } = useUserGroup();
  const [plan, setPlan] = useState<string | null>(null);
  useEffect(() => {
    let vivo = true;
    getUserPlan().then((p) => {
      if (vivo && p) setPlan(p);
    });
    return () => {
      vivo = false;
    };
  }, []);
  return isDevTester ? null : getModePlanLock(kind, plan);
}

/** La pantalla del candado: el título y el mensaje del piso, y "Ver planes". */
export function PantallaDePisoDePlan({ lock }: { lock: ModePlanLock }) {
  const navigate = useNavigate();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 px-8 text-center">
      <Lock className="h-8 w-8 text-[rgb(var(--brand-black-rgb)_/_0.4)]" aria-hidden="true" />
      <p className="text-[16px] font-semibold text-brand-black">{lock.title}</p>
      <p className="max-w-md text-[14px] text-[#3C3C43]/60">{lock.message}</p>
      <button
        type="button"
        onClick={() => navigate('/subscription')}
        className="mt-2 rounded-md bg-brand-primary px-5 py-2.5 text-[15px] font-semibold text-white transition-colors hover:bg-brand-primary-hover"
      >
        Ver planes
      </button>
    </div>
  );
}
